import { useApi } from '@mainstage/core-plugin-api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationApiRef } from '../notificationApiRef';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import {
  WebhookHeaderDeleteRequest,
  WebhookHeaderDeleteResponse,
} from '@agilelab/plugin-wb-notification-common';
import { WEBHOOK_HEADERS } from './reactQuery';

export const useDeleteWebhookHeader = (options?: {
  alertOnError?: boolean;
  alertOnSuccess?: boolean;
  invalidateQueryOnSuccess?: boolean;
}) => {
  const notificationApi = useApi(notificationApiRef);
  const alertApi = useApi(customAlertApiRef);
  const queryClient = useQueryClient();

  return useMutation<
    WebhookHeaderDeleteResponse,
    Error,
    WebhookHeaderDeleteRequest
  >({
    mutationFn: (request: WebhookHeaderDeleteRequest) =>
      notificationApi.deleteWebhookHeader(request),
    onSuccess: () => {
      if (options?.invalidateQueryOnSuccess !== false)
        queryClient.invalidateQueries({ queryKey: [WEBHOOK_HEADERS] });
      if (options?.alertOnSuccess !== false)
        alertApi.post({
          severity: 'success',
          message: 'Header deleted successfully',
        });
    },
    onError: e => {
      if (options?.alertOnError !== false)
        alertApi.post({
          severity: 'error',
          message: e.message,
        });
    },
  });
};
